/**
 * Specification accordion
 * ---------------------------------------------------------------
 * Uses event delegation on `document` so it works for every
 * .spec-accordion on the page (mobile + desktop instances) and
 * for any accordion that is added to the DOM after initial load.
 *
 * Markup contract (see snippets/specification-tabs.liquid):
 *
 *   <div class="spec-accordion">
 *     <div class="spec-accordion__item" [data-active]>
 *       <div class="spec-accordion__heading">…</div>
 *       <div class="spec-accordion__content">…</div>
 *     </div>
 *     …
 *   </div>
 */

(function () {
    function setHeight(content, height) {
        content.style.height = height;
    }

    // Set initial heights for items that are open on page load
    document.querySelectorAll('.spec-accordion__item[data-active]').forEach(item => {
        const content = item.querySelector('.spec-accordion__content');
        if (content) setHeight(content, content.scrollHeight + 'px');
    });

    // Single delegated click listener — handles all accordions on the page
    document.addEventListener('click', function (event) {
        const heading = event.target.closest('.spec-accordion__heading');
        if (!heading) return;

        const item = heading.closest('.spec-accordion__item');
        if (!item) return;

        const accordion = item.closest('.spec-accordion');
        if (!accordion) return;

        const isOpen = item.hasAttribute('data-active');

        // Close all other items in the same accordion
        accordion.querySelectorAll('.spec-accordion__item[data-active]').forEach(other => {
            if (other !== item) {
                setHeight(other.querySelector('.spec-accordion__content'), '0');
                other.removeAttribute('data-active');
            }
        });

        if (isOpen) {
            setHeight(item.querySelector('.spec-accordion__content'), '0');
            item.removeAttribute('data-active');
        } else {
            const content = item.querySelector('.spec-accordion__content');
            setHeight(content, content.scrollHeight + 'px');
            item.setAttribute('data-active', '');
        }
    });
})();

